<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <!-- <img src="@/assets/img/logo_white.png" alt="logo图" /> -->
    </div>
    <p class="title">极速数通（杭州）智能技术有限公司</p>
<!--    <p class="address_tel_fax">-->
<!--      <span>Tel：888-888-888</span>-->
<!--    </p>-->
<!--    <p class="email_wx">-->
<!--      <span>邮箱：xxx@163.com</span>-->
<!--    </p>-->
    <div class="copy">
      &copy;{{ new Date().getFullYear() }} 极速数通（杭州）智能技术有限公司 版权所有<br>
      <div style="display: flex;flex-direction: row;justify-content: center;">
        <a href="https://beian.miit.gov.cn/" style="color: #d3d3d3;"> 浙ICP备2023033842号-1</a>&nbsp;&nbsp;
        <img style="width: 18px;height: auto;" src="../assets/img/balogo.png">&nbsp;
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013720" style="color: #d3d3d3;" target="_blank">
          浙公网安备33010602013720
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 10px;
  /* height: 45px; */
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue